/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Fáðu aðgang að Pretty HTML ritlinum"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Athugun á aðgangi"
  },
  "action_to_take_b626a99a": {
    "message": "Aðgerð sem grípa á til:"
  },
  "add_8523c19b": {
    "message": "Bæta við"
  },
  "add_a_caption_2a915239": {
    "message": "Bæta við yfirskrift"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Bæta við öðrum texta fyrir myndina"
  },
  "add_another_f4e50d57": {
    "message": "Bæta við öðrum"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Bæta við skjátexta"
  },
  "add_image_60b2de07": {
    "message": "Bæta við mynd"
  },
  "add_one_9e34a6f8": {
    "message": "Bæta einum við!"
  },
  "additional_considerations_f3801683": {
    "message": "Auka umhugsunarefni"
  },
  "address_applied_64269b0b": {
    "message": "Heimilisfang notað"
  },
  "address_removed_fcb496e0": {
    "message": "Heimilisfang fjarlægt"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Samliggjandi tenglar með sömu vefslóð eiga að vera stakur tengill."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Jafna"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Stillingar og listar"
  },
  "all_4321c3a1": {
    "message": "Allt"
  },
  "all_apps_a50dea49": {
    "message": "Öll forrit"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Leyfa niðurhal margmiðlunarefnis"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Leyfa niðurhal á eftirritun"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Í stafrófsröð"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Annar texti ætti ekki að vera lengri en 120 stafir."
  },
  "alt_text_611fb322": {
    "message": "Annar texti"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (hjámargfeldi)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Villa kom upp þegar skráin var lesin"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Villa kom upp við netbeiðni"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Villa kom upp við að hlaða upp margmiðlunarefninu."
  },
  "and_7fcc2911": {
    "message": "Og"
  },
  "angle_c5b4ec50": {
    "message": "Horn"
  },
  "announcement_fb4cb645": {
    "message": "Tilkynning"
  },
  "announcement_list_da155734": {
    "message": "Tilkynningaskrá"
  },
  "announcements_a4b8ed4a": {
    "message": "Tilkynningar"
  },
  "apply_781a2546": {
    "message": "Virkja"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Notaðu breytingar á öll tilvik þessa tákngerðartákns í námskeiðinu"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nálgast mörkin"
  },
  "approximately_e7965800": {
    "message": "Um það bil"
  },
  "apps_54d24a47": {
    "message": "Smáforrit"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Viltu örugglega hætta við? Breytingar verða hugsanlega ekki vistaðar."
  },
  "arrows_464a3e54": {
    "message": "Örvar"
  },
  "art_icon_8e1daad": {
    "message": "Lista tákn"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Útlitshlutfall verður varðveitt"
  },
  "assignment_976578a8": {
    "message": "Verkefni"
  },
  "assignments_1e02582c": {
    "message": "Verkefni"
  },
  "asterisk_82255584": {
    "message": "Stjarna"
  },
  "attributes_963ba262": {
    "message": "Eiginleikar"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Hljóð- og myndupptaka ekki studd; vinsamlegast notaðu annan vafra."
  },
  "audio_options_feb58e2c": {
    "message": "Hljóðvalkostir"
  },
  "audio_options_tray_33a90711": {
    "message": "Hljóðvalkostabakki"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Hljóðspilari fyrir { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Sjálfvirkt vistað efni er til. Viltu hlaða inn sjálfvirkt vistuðu efni í staðinn?"
  },
  "available_folders_694d0436": {
    "message": "Tiltækar möppur"
  },
  "background_1bc88842": {
    "message": "Bakgrunnur"
  },
  "backslash_b2d5442d": {
    "message": "Öfugt skástrik"
  },
  "bar_ec63ed6": {
    "message": "Stika"
  },
  "basic_554cdc0a": {
    "message": "Grunnur"
  },
  "because_501841b": {
    "message": "Vegna"
  },
  "below_81d4dceb": {
    "message": "Undir"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Stór hringur"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Tvíliða stuðull"
  },
  "black_4cb01371": {
    "message": "Svartur"
  },
  "blue_daf8fea9": {
    "message": "Blár"
  },
  "bold_applied_42d547b7": {
    "message": "Feitletrað notað"
  },
  "bold_removed_da474a5c": {
    "message": "Feitletrað fjarlægt"
  },
  "border_5b08b06d": {
    "message": "Rammi"
  },
  "bottom_15a2a9be": {
    "message": "Neðst"
  },
  "bottom_third_5f5fec1d": {
    "message": "Neðsti þriðjungur"
  },
  "bowtie_5f9629e4": {
    "message": "Slaufa"
  },
  "brick_f2656265": {
    "message": "Kubbur"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Hætta við"
  },
  "cap_product_3a5265a6": {
    "message": "Stafafeldi"
  },
  "caption_manager_aae0906f": {
    "message": "Skjátextastjórnun"
  },
  "center_align_e68d9997": {
    "message": "Miðjujafna"
  },
  "centered_dot_64d5e378": {
    "message": "Miðjupunktur"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Láréttir miðjupunktar"
  },
  "change_alt_text_92654906": {
    "message": "Breyta öðrum texta"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Breyta tagi hauss í málsgrein"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Breyta aðeins stigi þessa hauss"
  },
  "change_text_color_1aecb912": {
    "message": "Breyta lit á texta"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Breytingar gilda eftir að þú vistar þessa síðu."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Breytingar verða hugsanlega ekki vistaðar."
  },
  "characters_9d897d1c": {
    "message": "Stafir"
  },
  "characters_no_spaces_485e5367": {
    "message": "Stafir (engin stafabil)"
  },
  "check_accessibility_3c78211c": {
    "message": "Kanna aðgengileika"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Er að kanna vandamál varðandi aðgengileika"
  },
  "chi_54a32644": {
    "message": "Khí"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Veldu skjátextaskrá"
  },
  "choose_usage_rights_33683854": {
    "message": "Velja notkunarréttindi..."
  },
  "circle_484abe63": {
    "message": "Hringur"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "gera hring utan um óraðaðan lista"
  },
  "clear_2084585f": {
    "message": "Hreinsa"
  },
  "clear_image_3213fe62": {
    "message": "Hreinsa mynd"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Smelltu eða shift-smelltu fyrir html ritilinn."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Smella til að fella inn { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Smelltu til að fela forskoðun"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Smellið til að setja tengil inn í ritilinn."
  },
  "click_to_show_preview_faa27051": {
    "message": "Smelltu til að sýna forskoðun"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Loka valmynd eða svarglugga. Fer líka með þig aftur í ritilssvæðið"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Loka athugun á aðgengileika"
  },
  "close_d634289d": {
    "message": "Loka"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Loka staðfestingarglugga flýtileiða lyklaborðs"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Skjátextaskrá verður að vera minni en { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Skjátextar"
  },
  "clubs_suit_c1ffedff": {
    "message": "Kylfur (búningur)"
  },
  "collab_575ac7bc": {
    "message": "Samstarf"
  },
  "collaborations_5c56c15f": {
    "message": "Samvinnutól"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Fella saman til að fela { types }"
  },
  "color_a363e1b0": {
    "message": "Litur"
  },
  "color_contrast_4c418add": {
    "message": "Birtuhlutfall litar"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Birtuhlutfall litar"
  },
  "color_picker_6b359edf": {
    "message": "Litaval"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Litaval ({ colorName } valið)"
  },
  "color_popup_af39810f": {
    "message": "Litasprettigluggi"
  },
  "column_e1ae5c64": {
    "message": "Dálkur"
  },
  "column_group_1c062368": {
    "message": "Dálkahópur"
  },
  "complex_numbers_a543d004": {
    "message": "Tvinntölur"
  },
  "computer_1d7dfa6f": {
    "message": "Tölva"
  },
  "congruent_5a244acd": {
    "message": "Samræmt"
  },
  "contains_311f37b7": {
    "message": "Inniheldur"
  },
  "content_1440204b": {
    "message": "Efni"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Efni í ritlinum verður breytt. Ýttu á Hætta við til að halda upprunalegu efni."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Enn er verið að hlaða upp efninu, ef þú heldur áfram verður það ekki innfellt á réttan hátt."
  },
  "content_subtype_5ce35e88": {
    "message": "Undirtegund efnis"
  },
  "content_type_2cf90d95": {
    "message": "Efnistegund"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Halda áfram að YouTube efni"
  },
  "coproduct_e7838082": {
    "message": "Hjámargfeldi"
  },
  "copyright_holder_66ee111": {
    "message": "Handhafi útgáfuréttar:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Gat ekki sett inn efni: „{ itemType }“ atriði eru ekki studd eins og er í Canvas."
  },
  "count_40eced3b": {
    "message": "Fjöldi"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 orð}\n    one {1 orð}\n  other {# orð}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# atriði hlaðið inn}\n  other {# atriðum hlaðið inn}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Skjöl námskeiðs"
  },
  "course_files_62deb8f8": {
    "message": "Námskeiðsskrár"
  },
  "course_files_a31f97fc": {
    "message": "Námskeiðsskrár"
  },
  "course_images_f8511d04": {
    "message": "Myndir námskeiðs"
  },
  "course_link_b369426": {
    "message": "Námskeiðstengill"
  },
  "course_links_b56959b9": {
    "message": "Tenglar námskeiðs"
  },
  "course_media_ec759ad": {
    "message": "Margmiðlunarefni námskeiðs"
  },
  "course_navigation_dd035109": {
    "message": "Leiðarnet námskeiðs"
  },
  "create_icon_110d6463": {
    "message": "Búa til tákn"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Búa til tákngerðartákn"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons leyfi:"
  },
  "crop_image_41bf940c": {
    "message": "Sníða mynd"
  },
  "crop_image_807ebb08": {
    "message": "Klippa mynd"
  },
  "cup_product_14174434": {
    "message": "Stafafeldi (Cup Product)"
  },
  "current_image_f16c249c": {
    "message": "Núverandi mynd"
  },
  "current_link_945a47ee": {
    "message": "Núverandi tengill"
  },
  "current_volume_level_c55ab825": {
    "message": "Núverandi stig hljóðstyrks"
  },
  "custom_6979cd81": {
    "message": "Sérsníða"
  },
  "cyan_c1d5f68a": {
    "message": "Blágrænn"
  },
  "dagger_57e0f4e5": {
    "message": "Tvíkross"
  },
  "date_added_ed5ad465": {
    "message": "Dagsetning bætt við"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Tákn til skreytingar"
  },
  "decorative_image_fde98579": {
    "message": "Skreytingarmynd"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Skrautlegt { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Minnka inndrátt"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Minnka Rich Content svæði"
  },
  "deep_purple_bb3e2907": {
    "message": "Dökkfjólublár"
  },
  "default_9db103d": {
    "message": "Sjálfgilt"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "sjálfvalinn áherslumerktur óraðaður listi"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "sjálfvalinn tölumerktur raðaður listi"
  },
  "definite_integral_fe7ffed1": {
    "message": "Ákveðin heild"
  },
  "degree_symbol_4a823d5f": {
    "message": "Gráðutákn"
  },
  "delimiters_4db4840d": {
    "message": "Afmarkarar"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Lýstu tákninu)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Lýsa { TYPE })"
  },
  "description_436c48d7": {
    "message": "Lýsing"
  },
  "details_98a31b68": {
    "message": "Upplýsingar"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Skápunktar"
  },
  "diamond_b8dfe7ae": {
    "message": "Demantur"
  },
  "diamonds_suit_526abaaf": {
    "message": "Demantar (búningur)"
  },
  "digamma_258ade94": {
    "message": "Dígamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Máltegund"
  },
  "directionality_26ae9e08": {
    "message": "Lestrarátt"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Breyta LaTeX beint"
  },
  "disable_preview_222bdf72": {
    "message": "Afvirkja forskoðun"
  },
  "discussion_6719c51d": {
    "message": "Umræða"
  },
  "discussions_a5f96392": {
    "message": "Umræður"
  },
  "discussions_index_6c36ced": {
    "message": "Umræðuskrá"
  },
  "disjoint_union_e74351a8": {
    "message": "Ósamræmt samband"
  },
  "display_options_315aba85": {
    "message": "Sýningar valkostir"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Sýna textatengil (opnast í nýjum flipa)"
  },
  "div_applied_49ad83fc": {
    "message": "Deiling notuð"
  },
  "div_removed_d13f8e17": {
    "message": "Deiling fjarlægð"
  },
  "division_sign_72190870": {
    "message": "Deilingartákn"
  },
  "document_678cd7bf": {
    "message": "Skjal"
  },
  "documents_81393201": {
    "message": "Skjöl"
  },
  "done_54e3d4b6": {
    "message": "Lokið"
  },
  "double_dagger_faf78681": {
    "message": "Tvöfaldur tvíkross"
  },
  "down_5831a426": {
    "message": "Niður"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Skáör niður og til vinstri"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Skáör niður og til hægri"
  },
  "download_filename_2baae924": {
    "message": "Hlaða niður { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Ör niður á við"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Þríhyrningur sem bendir niður"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Draga skrá hingað"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Dragðu og slepptu, eða smelltu til að vafra í tölvunni"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Drag handfang. Nota upp og niður örvarnar til að breyta stærð"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Skil: Margar dagsetningar"
  },
  "due_when_7eed10c6": {
    "message": "Skil: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Breyta öðrum texta fyrir þetta tákndæmi"
  },
  "edit_c5fbea07": {
    "message": "Breyta"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Breyta námskeiðstengli"
  },
  "edit_equation_f5279959": {
    "message": "Breyta jöfnu"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Breyta núverandi tákngerðartákni"
  },
  "edit_icon_2c6b0e91": {
    "message": "Breyta tákni"
  },
  "edit_link_7f53bebb": {
    "message": "Breyta tengli"
  },
  "editor_status_bar_653f44ee": {
    "message": "Stöðustika ritils"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Eining byrjar á { start }"
  },
  "embed_828fac4a": {
    "message": "Fella inn"
  },
  "embed_code_314f1bd5": {
    "message": "Fella inn kóða"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Fella inn efni frá ytra verkfæri"
  },
  "embed_image_1080badc": {
    "message": "Fella inn mynd"
  },
  "embed_video_a97a64af": {
    "message": "Fella inn myndband"
  },
  "embedded_content_aaeb4d3d": {
    "message": "innfellt efni"
  },
  "empty_set_91a92df4": {
    "message": "Autt mengi"
  },
  "encircled_dot_8f5e51c": {
    "message": "Punktur inni í hring"
  },
  "encircled_minus_72745096": {
    "message": "Mínus inni í hring"
  },
  "encircled_plus_36d8d104": {
    "message": "Plús inni í hring"
  },
  "encircled_times_5700096d": {
    "message": "Tímar inni í hring"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Verkfræði tákn"
  },
  "english_icon_25bfe845": {
    "message": "Ensku tákn"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Sláðu inn titil margmiðlunarefnis"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Sláðu inn minnst 3 stafi til að leita"
  },
  "enter_replacement_text_17631bbc": {
    "message": "færðu inn skiptitexta"
  },
  "enter_search_text_26cb4459": {
    "message": "færðu inn leitartexta"
  },
  "epsilon_54bb8afa": {
    "message": "Epsílon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsílon (afbrigði)"
  },
  "equals_sign_c51bdc58": {
    "message": "Samasemmerki"
  },
  "equation_1c5ac93c": {
    "message": "Jafna"
  },
  "equation_editor_39fbc3f1": {
    "message": "Jöfnuritstjóri"
  },
  "equilibrium_6ff3040b": {
    "message": "Jafnvægi"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Jafngildisflokkur"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Jafngildi (auðkenni)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Er til"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Fara úr heilskjá"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Víkka forskoðun sjálfgefið"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Útvíkka til að sjá { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Ytri tengill"
  },
  "external_tool_frame_70b32473": {
    "message": "Ytri verkfærisrammi"
  },
  "external_tools_6e77821": {
    "message": "Ytri tæki"
  },
  "extra_large_b6cdf1ff": {
    "message": "Sérstaklega stórar"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Mjög stórt ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Sérstaklega smátt"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Utanskóla tákn"
  },
  "f_function_fe422d65": {
    "message": "F (virkni)"
  },
  "fail_544e5dde": {
    "message": "FALL"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Gat ekki sótt skráarinnihald"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Mistókst að sækja efni frá ytra verkfæri"
  },
  "file_name_8fd421ff": {
    "message": "Skráarheiti"
  },
  "file_preview_21667a6e": {
    "message": "Forskoðun skrár"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Forskoðun skrár fyrir { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Farið yfir skráageymslukvóta"
  },
  "file_url_c12b64be": {
    "message": "Skráar-URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } skráartákn"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } forskoðun myndar"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } forskoðun texta"
  },
  "files_c300e900": {
    "message": "Skrár"
  },
  "files_index_af7c662b": {
    "message": "Skráalisti"
  },
  "find_8d605019": {
    "message": "Finna"
  },
  "find_and_replace_6e345933": {
    "message": "Finna og skipta út"
  },
  "finish_bc343002": {
    "message": "Ljúka"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Lagfæra stigveldi hauss"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (tónlist)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Valkostir tækjastiku fyrir fókuseiningu"
  },
  "folder_tree_fbab0726": {
    "message": "Möpputré"
  },
  "for_all_b919f972": {
    "message": "Fyrir alla"
  },
  "format_4247a9c5": {
    "message": "Snið"
  },
  "format_as_a_list_142210c3": {
    "message": "Sníða sem lista"
  },
  "formatting_5b143aa8": {
    "message": "Forsníð"
  },
  "forward_slash_3f90f35e": {
    "message": "Skástrik"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Sjálfvirkt vistað efni fannst"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Fann { count, plural,\n     =0 {# niðurstöður}\n    one {# niðurstaða}\n  other {# niðurstöður}\n}"
  },
  "fraction_41bac7af": {
    "message": "Brot"
  },
  "fullscreen_873bf53f": {
    "message": "Allur skjárinn"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Býr til forskoðun..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Myndir á GIF/PNG sniði sem eru stærri en { size } KB eru ekki studdar eins og er."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Fara í valmyndarslá ritilsins"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Fara í verkfæraslá ritilsins"
  },
  "grades_a61eba0a": {
    "message": "Einkunnir"
  },
  "graphics_text_bc9568bc": {
    "message": "Grafískur texti"
  },
  "greater_than_e98af662": {
    "message": "Stærra en"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Stærra en eða jafnt og"
  },
  "greek_65c5b3f7": {
    "message": "Gríska"
  },
  "green_15af4778": {
    "message": "Grænn"
  },
  "grey_a55dceff": {
    "message": "Grár"
  },
  "group_documents_8bfd6ae6": {
    "message": "Skjöl hóps"
  },
  "group_files_4324f3df": {
    "message": "Hópskrár"
  },
  "group_files_82e5dcdb": {
    "message": "Hópskrár"
  },
  "group_images_98e0ac17": {
    "message": "Myndir hóps"
  },
  "group_isomorphism_45b1458c": {
    "message": "Hópeinslögun"
  },
  "group_link_63e626b3": {
    "message": "Hóptengill"
  },
  "group_links_9493129e": {
    "message": "Hóptenglar"
  },
  "group_media_2f3d128a": {
    "message": "Miðlar hóps"
  },
  "group_navigation_99f191a": {
    "message": "Leiðarstýring hóps"
  },
  "h_bar_bb94deae": {
    "message": "H-stika"
  },
  "hat_ea321e35": {
    "message": "Hat"
  },
  "header_column_f27433cb": {
    "message": "Dálkur fyrir haus"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Röð og dálkur fyrir haus"
  },
  "header_row_f33eb169": {
    "message": "Röð fyrir haus"
  },
  "heading_2_5b84eed2": {
    "message": "Fyrirsögn 2"
  },
  "heading_3_2c83de44": {
    "message": "Fyrirsögn 3"
  },
  "heading_4_b2e74be7": {
    "message": "Fyrirsögn 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Haus { h } notaður"
  },
  "heading_h_removed_745f24a6": {
    "message": "Haus { h } fjarlægður"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Ekki ætti að sleppa stigi hauss."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Haus byrjar á { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Haus ætti ekki að innihalda fleiri en 120 stafi."
  },
  "health_icon_8d292eb5": {
    "message": "Heilsu tákn"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hjörtu (búningur)"
  },
  "height_69b03e15": {
    "message": "Hæð"
  },
  "hexagon_d8468e0d": {
    "message": "Sexhyrningur"
  },
  "hide_description_bfb5502e": {
    "message": "Fela lýsingu"
  },
  "hide_title_description_caf092ef": {
    "message": "Fela { title } lýsingu"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Auðkenndu einingu til að virkja tækjastikuna fyrir einingarvalkosti"
  },
  "home_351838cd": {
    "message": "Heim"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Hvernig á að óska eftir og breyta skjátextum?"
  },
  "html_code_editor_fd967a44": {
    "message": "html kóðaritill"
  },
  "html_editor_fb2ab713": {
    "message": "HTML ritill"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Ég hef heimild til að nota þessa skrá."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Ég hef höfundarréttinn"
  },
  "icon_215a1dc6": {
    "message": "Tákn"
  },
  "icon_8168b2f8": {
    "message": "tákn"
  },
  "icon_color_b86dd6d6": {
    "message": "Litur tákns"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Tákngerðartákn"
  },
  "icon_options_7e32746e": {
    "message": "Valkostir tákns"
  },
  "icon_options_tray_2b407977": {
    "message": "Valkostabakki tákns"
  },
  "icon_preview_1782a1d9": {
    "message": "Forskoðun tákns"
  },
  "icon_shape_30b61e7": {
    "message": "Form tákns"
  },
  "icon_size_9353edea": {
    "message": "Stærð tákns"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Ef hann er skilinn eftir tómur birtist tenglatexti sem heiti námskeiðstengils"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Ef þörf er á notkunarrétti birtist skráin ekki fyrr en hún er virk á síðunni Skrár."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Ef þú velur ekki notkunarréttindi núna verður þessi skrá óbirt eftir að henni hefur verið hlaðið upp."
  },
  "image_8ad06": {
    "message": "Mynd"
  },
  "image_c1c98202": {
    "message": "mynd"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Ekki ætti að nota skrárheiti myndar sem annan texta til að lýsa innihaldi myndar."
  },
  "image_options_5412d02c": {
    "message": "Valkostir myndar"
  },
  "image_options_tray_90a46006": {
    "message": "Valkostir myndar bakki"
  },
  "image_to_crop_3a34487d": {
    "message": "Mynd til að klippa"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Mynd með skrárheitinu { file }"
  },
  "images_7ce26570": {
    "message": "Myndir"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Myndir ættu að fela í sér annan texta sem lýsir innihaldi myndarinnar."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Ímyndaður hluti (af flókinni tölu)"
  },
  "in_element_of_19ca2f33": {
    "message": "Í (hluti af)"
  },
  "increase_indent_6af90f7c": {
    "message": "Auka inndrátt"
  },
  "increase_rich_content_area_340b775": {
    "message": "Stækka Rich Content svæði"
  },
  "indefinite_integral_6623307e": {
    "message": "Óákveðin heild"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } af { max }"
  },
  "indigo_2035fc55": {
    "message": "Dimmfjólublár"
  },
  "inference_fed5c960": {
    "message": "Ályktun"
  },
  "infinity_7a10f206": {
    "message": "Óendanleiki"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Inntaksreitur fyrir alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Inntaksreitur fyrir bláan"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Inntaksreitur fyrir grænan"
  },
  "input_field_for_red_86a84615": {
    "message": "Inntaksreitur fyrir rauðan"
  },
  "insert_593145ef": {
    "message": "Setja inn"
  },
  "insert_link_6dc23cae": {
    "message": "Setja inn tengil"
  },
  "insert_math_equation_57c6e767": {
    "message": "Setja inn stærðfræðijöfnu"
  },
  "integers_336344e1": {
    "message": "Heilar tölur"
  },
  "intersection_cd4590e4": {
    "message": "Sniðmengi"
  },
  "invalid_description_991e23bb": {
    "message": "Ógild lýsing"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ógild færsla."
  },
  "invalid_file_c11ba11": {
    "message": "Ógild skrá"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ógild skráartegund"
  },
  "invalid_url_cbde79f": {
    "message": "Ógild vefslóð"
  },
  "iota_11c932a9": {
    "message": "jóta"
  },
  "issue_num_total_f94536cf": {
    "message": "Vandamál { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Skáletrað notað"
  },
  "italic_removed_17cbab6f": {
    "message": "Skáletrað fjarlægt"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (afbrigði)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Flýtilyklar"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Nota dálklykil til að fara á tengla. Tveir samliggjandi tenglar sem vísa á sama ákvörðunarstað geta valdið ruglingi hjá þeim sem nota lyklaborð."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Tungumálalistar tákn"
  },
  "languages_icon_9d20539": {
    "message": "Tungumála tákn"
  },
  "large_9c5e80e7": {
    "message": "Stór"
  },
  "large_text_e7ba08cd": {
    "message": "Stór texti"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Stórt ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Læra"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Fá að vita meira um samliggjandi tengla"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Fá að vita meira um litaandstæður"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Fá að vita meira um skipulag á síðuhausum"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Fá að vita meira um rétta uppbyggingu síðuhausa"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Fá að vita meira um töfluhausa"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Fá að vita meira um notkun annars texta fyrir myndir"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Fá að vita meira um notkun yfirskriftar með töflum"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Fá að vita meira um notkun skráaheita sem annan texta"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Fá að vita meira um notkun lista"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Fá að vita meira um notkun umfangseiginda með töflum"
  },
  "leave_as_is_4facfe55": {
    "message": "Halda óbreyttu"
  },
  "left_3ea9d375": {
    "message": "Vinstri"
  },
  "left_align_43d95491": {
    "message": "Vinstri jafna"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Vinstri hornsvigi"
  },
  "left_arrow_4fde1a64": {
    "message": "Vinstri ör"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Vinstri ör með krók"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Vinstra þak"
  },
  "left_curly_brace_1726fb4": {
    "message": "Vinstri slaufusvigi"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Vinstri ör niður á við með skutli"
  },
  "left_floor_29ac2274": {
    "message": "Vinstra gólf"
  },
  "left_to_right_e9b4fd06": {
    "message": "Vinstri til hægri"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Vinstri ör upp á við með skutli"
  },
  "leftward_arrow_1e4765de": {
    "message": "Ör til vinstri"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Þríhyrningur sem bendir til vinstri"
  },
  "less_than_a26c0641": {
    "message": "Minna en"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Minna eða jafnt og"
  },
  "library_icon_ae1e54cf": {
    "message": "Bóksafns tákn"
  },
  "light_blue_5374f600": {
    "message": "Ljósblár"
  },
  "link_7262adec": {
    "message": "Tengill"
  },
  "link_options_a16b758b": {
    "message": "Valkostir tengils"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "gerð tengils: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Tengill með texta byrjar á { start }"
  },
  "links_14b70841": {
    "message": "Tenglar"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Tenglar á ytra svæði."
  },
  "lists_cd1336fc": {
    "message": "Listar"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lista ætti að sníða sem lista."
  },
  "load_more_35d33c7": {
    "message": "Hlaða meira"
  },
  "loading_25990131": {
    "message": "Hleð inn..."
  },
  "loading_bde52856": {
    "message": "Sæki"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Mistókst að hlaða skjátexta/texta."
  },
  "loading_external_tool_d839042c": {
    "message": "Hleður ytra verkfæri"
  },
  "loading_failed_b3524381": {
    "message": "Mistókst að hlaða..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Hleðsla mistókst."
  },
  "loading_folders_d8b5869e": {
    "message": "Hleð möppum"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Hleður staðgengli fyrir { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Hleður, augnablik"
  },
  "loading_preview_9f077aa1": {
    "message": "Hlaða forskoðun"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Læsa hraða við 1x"
  },
  "locked_762f138b": {
    "message": "Læst"
  },
  "logical_equivalence_76fca396": {
    "message": "Rökrétt jafngildi"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Rökrétt jafngildi (stutt)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Rökrétt jafngildi (stutt og breitt)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Rökrétt jafngildi (breitt)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Lágir láréttir miðjupunktar"
  },
  "magenta_4a65993c": {
    "message": "Blárauður"
  },
  "maps_to_e5ef7382": {
    "message": "Varpanir til"
  },
  "math_icon_ad4e9d03": {
    "message": "Stærðfræði tákn"
  },
  "media_af190855": {
    "message": "Miðill"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Miðilsskrá er í vinnslu. Vinsamlegast reyndu aftur seinna."
  },
  "media_options_saved_560c4ec8": {
    "message": "Valkostir miðla vistaðir."
  },
  "media_title_2112243b": {
    "message": "Heiti margmiðlunarefnis"
  },
  "medium_5a8e9ead": {
    "message": "Meðal"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Miðlungs ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Fella tengla saman"
  },
  "mic_a7f3d311": {
    "message": "Hljóðnemi"
  },
  "microphone_disabled_15c83130": {
    "message": "Slökkt á hljóðnema"
  },
  "middle_27dc1d5": {
    "message": "Miðja"
  },
  "minimize_file_preview_da911944": {
    "message": "Lágmarka forskoðun skrár"
  },
  "minimize_video_20aa554b": {
    "message": "Minnka myndband"
  },
  "minus_fd961e2e": {
    "message": "Mínus"
  },
  "minus_plus_3461f637": {
    "message": "Mínus/Plús"
  },
  "misc_3b692ea7": {
    "message": "Ýmislegt"
  },
  "miscellaneous_e9818229": {
    "message": "Ýmislegt"
  },
  "module_90d9fd32": {
    "message": "Eining"
  },
  "modules_c4325335": {
    "message": "Námsefni"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Flytja mynd til að klippa { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Fjöllita mynd"
  },
  "multiplication_sign_15f95c22": {
    "message": "Margföldunarmerki"
  },
  "music_icon_4db5c972": {
    "message": "Tónlistar tákn"
  },
  "my_files_2f621040": {
    "message": "Mínar skrár"
  },
  "n_th_root_9991a6e4": {
    "message": "N-ta rót"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nafn"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Náttúruleg (tónlist)"
  },
  "natural_numbers_3da07060": {
    "message": "Náttúruleg tala"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Notaðu valmyndina eða verkfæraslánna til að komast á réttan stað"
  },
  "navigation_ee9af92d": {
    "message": "Leiðarstýring"
  },
  "nested_greater_than_d852e60d": {
    "message": "Faldað stærra en"
  },
  "nested_less_than_27d17e58": {
    "message": "Faldað minna en"
  },
  "new_quiz_34aacba6": {
    "message": "Nýtt próf"
  },
  "next_40e12421": {
    "message": "Næsti"
  },
  "next_findtext_9d69f0fe": {
    "message": "Næst { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Engin vandamál fundust varðandi aðgengileika."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Engar tilkynningar búnar til ennþá."
  },
  "no_announcements_found_20185afc": {
    "message": "Engar tilkynningar fundust."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Engin verkefni búin til ennþá."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Engin verkefni fundust."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Engar breytingar til að vista."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Engar umræður búnar til ennþá."
  },
  "no_discussions_found_9284063b": {
    "message": "Engar umræður fundust."
  },
  "no_e16d9132": {
    "message": "Nei"
  },
  "no_file_chosen_9a880793": {
    "message": "Engin skrá valin"
  },
  "no_headers_9bc7dc7f": {
    "message": "Engir hausar"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Ekkert námsefni búið til ennþá."
  },
  "no_modules_found_2df43a40": {
    "message": "Ekkert námsefni fannst."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Engar síður búnar til ennþá."
  },
  "no_pages_found_6799350": {
    "message": "Engar síður fundust."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Engin forskoðun tiltæk fyrir þessa skrá."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Engin próf búin til ennþá."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Engin próf fundust."
  },
  "no_results_940393cf": {
    "message": "Engar niðurstöður."
  },
  "no_results_found_58717065": {
    "message": "Engar niðurstöður fundust"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Engar niðurstöður fundust fyrir { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ekkert myndband"
  },
  "none_3b5e34d2": {
    "message": "Ekkert"
  },
  "none_selected_b93d56d2": {
    "message": "Ekkert valið"
  },
  "normal_text_7b03da48": {
    "message": "Venjulegur texti"
  },
  "not_equal_6e2980e6": {
    "message": "Ekki jafnt"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ekki í (ekki hluti af)"
  },
  "not_negation_1418ebb8": {
    "message": "Ekki (neitun)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ekki hlutmengi"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ekki hlutmengi (strangt)"
  },
  "not_superset_5556b913": {
    "message": "Ekki yfirmengi"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ekki yfirmengi (strangt)"
  },
  "nu_1c0f6848": {
    "message": "Ní"
  },
  "octagon_e48be9f": {
    "message": "Átthyrningur"
  },
  "olive_6a3e4d6b": {
    "message": "Ólífa"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Einum af eftirfarandi stílum verður að bæta við til að vista tákn: Táknlitur, útlínustærð, tákntexti eða mynd"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Ekki tókst að líma eina eða fleiri skrár. Vinsamlegast reyndu að hlaða upp eða draga og sleppa skrám."
  },
  "open_circle_e9bd069": {
    "message": "Opinn hringur"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Opna svarglugga flýtilykla"
  },
  "open_title_application_fd624fc5": {
    "message": "Opna { title } forrit"
  },
  "operators_a2ef9a93": {
    "message": "Stjórnendur"
  },
  "options_3ab0ea65": {
    "message": "Valkostir"
  },
  "or_9b70ccaa": {
    "message": "Eða"
  },
  "orange_81386a62": {
    "message": "Appelsínugulur"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Raðaðir og óraðaðir listar"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Aðra flýtivísa ritils má finna á"
  },
  "outline_color_3ef2cea7": {
    "message": "Útlínulitur"
  },
  "outline_size_a6059a21": {
    "message": "Útlínustærð"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } er ekki gild samskiptaregla."
  },
  "page_50c4823d": {
    "message": "Síða"
  },
  "pages_e5414c2c": {
    "message": "Síður"
  },
  "paragraph_5e5ad8eb": {
    "message": "Málsgrein"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Málsgrein notuð"
  },
  "paragraph_removed_d09320e": {
    "message": "Málsgrein fjarlægð"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Málsgrein byrjar á { start }"
  },
  "parallel_d55d6e38": {
    "message": "Samsíða"
  },
  "partial_derivative_4a9159df": {
    "message": "Hluti (afleitt)"
  },
  "pass_1c19a2b3": {
    "message": "STAÐIÐ"
  },
  "paste_5963d1c1": {
    "message": "Líma"
  },
  "pause_12af3bb4": {
    "message": "Gera hlé"
  },
  "pentagon_17d82ea3": {
    "message": "fimmhyrningur"
  },
  "people_b4ebb13c": {
    "message": "Fólk"
  },
  "percentage_34ab7c2c": {
    "message": "Hlutfall"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Prósenta verður að vera tala"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Prósenta verður að vera að minnsta kosti { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Sviðslista tákn"
  },
  "perpendicular_7c48ede4": {
    "message": "Hornréttur"
  },
  "phi_4ac33b6d": {
    "message": "Fí"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Fí (afbrigði)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Íþrótta tákn"
  },
  "pi_dc4f0bd8": {
    "message": "Pí"
  },
  "pi_variant_10f5f520": {
    "message": "Pí (afbrigði)"
  },
  "pick_a_color_557abfb0": {
    "message": "Veldu lit"
  },
  "pink_68ad45cb": {
    "message": "Bleikur"
  },
  "pixels_52ece7d1": {
    "message": "Punktar"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Punktar verða að vera að minnsta kosti { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Spila"
  },
  "play_media_comment_35257210": {
    "message": "Spila miðilsathugasemd."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Spila miðilsathugasemd eftir { name } frá { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Uppsetning spilara"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Leyfðu Canvas að fá aðgang að hljóðnemanum og vefmyndavélinni."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Veldu skrá"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Settu inn skráarheiti"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Sláðu inn gilda vefslóð fyrir myndband frá studdum verkvangi."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Veldu skrá af studdri tegund"
  },
  "plus_d43cd4ec": {
    "message": "Plús"
  },
  "plus_minus_f8be2e83": {
    "message": "Plús/Mínus"
  },
  "posted_when_a578f5ab": {
    "message": "Birt: { when }"
  },
  "power_set_4f26f316": {
    "message": "Aflmengi"
  },
  "precedes_196b9aef": {
    "message": "Kemur á undan"
  },
  "precedes_equal_20701e84": {
    "message": "Kemur á undan jafnt"
  },
  "preformatted_d0670862": {
    "message": "Forsniðnir"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Fyrri"
  },
  "preview_53003fd2": {
    "message": "Forskoðun"
  },
  "preview_a3f8f854": {
    "message": "FORSKOÐA"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Forskoðun með yfirlagningu"
  },
  "preview_inline_9787330": {
    "message": "Forskoðun í línu"
  },
  "previous_bd2ac015": {
    "message": "Fyrri"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Fyrri { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Áður valdir litir"
  },
  "prime_917ea60e": {
    "message": "Frum"
  },
  "prime_numbers_13464f61": {
    "message": "Frumtölur"
  },
  "product_39cf144f": {
    "message": "Feldi"
  },
  "proportional_f02800cc": {
    "message": "Hlutfallslegt"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Samskiptaregla verður að vera ftp, http, https, mailto, skype, tel eða henni verður sleppt."
  },
  "psi_e3f5f0f7": {
    "message": "Psí"
  },
  "published_c944a23d": {
    "message": "birt"
  },
  "published_when_302d8e23": {
    "message": "Birt: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Grasker"
  },
  "purple_7678a9fc": {
    "message": "Fjólublár"
  },
  "quaternions_877024e0": {
    "message": "Fertölur"
  },
  "quiz_e0dcce8f": {
    "message": "Próf"
  },
  "quizzes_7e598f57": {
    "message": "Próf"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rökréttar tölur"
  },
  "real_numbers_7c99df94": {
    "message": "Raunverulegar tölur"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Raunverulegur hluti (af flókinni tölu)"
  },
  "record_7c9448b": {
    "message": "Upptaka"
  },
  "record_upload_media_5fdce166": {
    "message": "Taka/hlaða upp margmiðlunarefni"
  },
  "recording_98da6bda": {
    "message": "Upptaka"
  },
  "red_8258edf3": {
    "message": "Rauður"
  },
  "relationships_6602af70": {
    "message": "Sambönd"
  },
  "religion_icon_246e0be1": {
    "message": "Trúar tákn"
  },
  "remove_f47dc62a": {
    "message": "Fjarlægja"
  },
  "remove_filename_3ea029f6": {
    "message": "Fjarlægja { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Fjarlægja stíl hauss"
  },
  "remove_link_d1f2f4d0": {
    "message": "Fjarlægja tengil"
  },
  "replace_all_d3d68b3": {
    "message": "Skipta um allt"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Skipta út öllu { findText } fyrir { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Skipta út"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Skipta út { findText } fyrir { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Skipta um með"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Skipt út { alertFindText } fyrir { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Skipt út öllu { alertFindText } fyrir { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Endurstilla"
  },
  "resize_ec83d538": {
    "message": "Breyta stærð"
  },
  "restore_auto_save_deccd84b": {
    "message": "Endurheimta sjálfvirka vistun?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Niðurstaða { index } af { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Afturkross (gefur ekki af sér)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Hró (afbrigði)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich Content ritill"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Svæði með mótuðum texta. Ýttu á { OSKey }+F8 fyrir flýtilykla Rich Content ritils."
  },
  "right_71ffdc4d": {
    "message": "Hægri"
  },
  "right_align_39e7a32a": {
    "message": "Hægri jafna"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Hægri hornsvigi"
  },
  "right_arrow_35e0eddf": {
    "message": "Hægri ör"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Hægri ör með krók"
  },
  "right_ceiling_839dc744": {
    "message": "Hægra þak"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Hægri slaufusvigi"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Hægri ör niður á við með skutli"
  },
  "right_floor_5392d5cf": {
    "message": "Hægra gólf"
  },
  "right_to_left_9cfb092a": {
    "message": "Hægri til vinstri"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Hægri ör upp á við með skutli"
  },
  "rightward_arrow_32932107": {
    "message": "Ör til hægri"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Þríhyrningur sem bendir til hægri"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Snúa mynd -90 gráður"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Snúa mynd 90 gráður"
  },
  "rotation_9699c538": {
    "message": "Snúningur"
  },
  "row_fc0944a7": {
    "message": "Röð"
  },
  "row_group_979f5528": {
    "message": "Raðahópur"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Því miður er ekki hægt að nota lyklaborð með pretty HTML ritlinum. Aðgangur að hráa HTML ritlinum hér."
  },
  "save_11a80ec3": {
    "message": "Vista"
  },
  "save_copy_ca63944e": {
    "message": "Vista afrit"
  },
  "save_media_cb9e786e": {
    "message": "Vista miðil"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Vistað tákngerðartákn"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Skjálesarar geta ekki ákvarðað efni myndar án annars texta, og skrárheiti eru oft merkingarlausir strengir með tölustöfum og bókstöfum sem lýsa ekki innhaldinu eða merkingunni."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Skjálesarar geta ekki ákvarðað efni myndar án annars texta sem lýsir innihaldi og merkingu myndarinnar. Annar texti ætti að vera einfaldur og hnitmiðaður."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Skjálesarar geta ekki ákvarðað efni myndar án annars texta sem lýsir innihaldi og merkingu myndarinnar."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Skjálesarar geta ekki túlkað töflur nema þær séu á réttu formi. Töfluhausar gefa upplýsingar um efni og innihald."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Skjálesarar geta ekki túlkað töflur nema þær séu á réttu formi. Yfirskrift töflu lýsir innihaldi hennar og gefur almennar upplýsingar um töfluna."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Skjálesarar geta ekki túlkað töflur nema þær séu á réttu formi. Töfluhausar gefa upplýsingar um efni og yfirlit yfir það sem fram kemur í töflunni."
  },
  "script_l_42a7b254": {
    "message": "Forskrift L"
  },
  "search_280d00bd": {
    "message": "Leita"
  },
  "select_audio_source_21043cd5": {
    "message": "Velja hljóðskrá"
  },
  "select_crop_shape_d441feeb": {
    "message": "Veldu klippiform"
  },
  "select_language_7c93a900": {
    "message": "Velja tungumál"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Veldu myndband"
  },
  "selected_274ce24f": {
    "message": "Valið"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Valið { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Val"
  },
  "set_header_scope_8c548f40": {
    "message": "Stilla gildissvið hauss"
  },
  "set_minus_b46e9b88": {
    "message": "Mínusmengi"
  },
  "set_table_header_cfab13a0": {
    "message": "Stilla töfluhaus"
  },
  "sharp_music_ab956814": {
    "message": "Skarpt (tónlist)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT + örvar"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O til að opna pretty html ritilinn."
  },
  "shortcut_911d6255": {
    "message": "Flýtileið"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Sýna valkosti myndar"
  },
  "show_link_options_545338fd": {
    "message": "Sýna valkosti tengla"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Sýna rúllandi eftirritun"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Sýna rúllandi eftirritun"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Notendur sem sjá fara hratt í gegnum vefsíður og leita að stórum eða feitletruðum hausum. Skjálesarar nýta sér hausa til að skilja samhengi. Hausar ættu að vera uppbyggðir á réttan hátt."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Notendur sem sjá fara hratt í gegnum vefsíður og leita að stórum eða feitletruðum hausum. Skjálesarar nýta sér hausa til að skilja samhengi. Hausar ættu að vera hnitmiðaðir og uppbyggðir á réttan hátt."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (afbrigði)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Einlita mynd"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Einlita myndlitur"
  },
  "size_b30e1077": {
    "message": "Stærð"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Stærð skjátextaskrár er stærri en { max } kb leyfileg mesta skráarstærð."
  },
  "small_b070434a": {
    "message": "Lítil"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Lítið ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Heill hringur"
  },
  "something_went_wrong_89195131": {
    "message": "Eitthvað fór úrskeiðis."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Eitthvað misfórst við aðgang að vefmyndavélinni."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Eitthvað mistókst og ég veit ekki hvað ég á að sýna þér."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Eitthvað fór úrskeiðis. Athugaðu tenginguna þína, endurhlaða síðuna og reyndu aftur."
  },
  "something_went_wrong_d238c551": {
    "message": "Eitthvað mistókst"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Eitthvað fór úrskeiðis við að deila skjánum þínum."
  },
  "sort_by_e75f9e3e": {
    "message": "Raða eftir"
  },
  "spades_suit_b37020c2": {
    "message": "Spaðar (búningur)"
  },
  "square_511eb3b3": {
    "message": "Ferningur"
  },
  "square_cap_9ec88646": {
    "message": "Ferstafur"
  },
  "square_cup_b0665113": {
    "message": "Ferfeldi (Square Cup)"
  },
  "square_root_e8bcbc60": {
    "message": "Kvaðratrót"
  },
  "square_root_symbol_d0898a53": {
    "message": "Kvaðratrótarmerki"
  },
  "square_subset_17be67cb": {
    "message": "Ferningshlutmengi"
  },
  "square_subset_strict_7044e84f": {
    "message": "Ferningshlutmengi (strangt)"
  },
  "square_superset_3be8dae1": {
    "message": "Ferningsyfirmengi"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Ferningsyfirmengi (strangt)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "gera ferning utan um óraðaðan lista"
  },
  "star_8d156e09": {
    "message": "Stjarna"
  },
  "start_over_f7552aa9": {
    "message": "Byrja aftur frá byrjun"
  },
  "start_recording_9a65141a": {
    "message": "Hefja upptöku"
  },
  "steel_blue_14296f08": {
    "message": "Stálblár"
  },
  "studio_media_options_ee504361": {
    "message": "Valkostir Studio Media"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Valmöguleikabakki Studio margmiðlunarefnis"
  },
  "styles_2aa721ef": {
    "message": "Stílar"
  },
  "submit_a3cc6859": {
    "message": "Leggja fram"
  },
  "submitting_b90fac62": {
    "message": "Skila..."
  },
  "subscript_59744f96": {
    "message": "Undirskrift"
  },
  "subset_19c1a92f": {
    "message": "Hlutmengi"
  },
  "subset_strict_8d8948d6": {
    "message": "Hlutmengi (strangt)"
  },
  "succeeds_9cc31be9": {
    "message": "Kemur á eftir"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Kemur á eftir og jafnt"
  },
  "sum_b0842d31": {
    "message": "Summa"
  },
  "superscript_8cb349a2": {
    "message": "Yfirskrift"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Brjóstvísir og hnévísir"
  },
  "superset_c4db8a7a": {
    "message": "Yfirmengi"
  },
  "superset_strict_c77dd6d2": {
    "message": "Yfirmengi (strangt)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Studdar skráagerðir: SRT eða WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Skipta yfir í pretty HTML-ritil"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Skipta yfir í hráan HTML-ritil"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Skipta í html ritilinn"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Skipta í ríka textaritilinn"
  },
  "syllabus_f191f65b": {
    "message": "Kennsluáætlun"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Kerfishljóð leyft"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Slökkt á kerfishljóði"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/örvar"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Haus töflu byrjar á { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tafla byrjar á { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Töfluhausar ættu að tiltaka gildissvið."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Töflur ættu að hafa yfirskrift sem lýsir innihaldi töflunnar."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Töflur ættu að hafa að minnsta kosti einn haus."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Grænblár"
  },
  "text_7f4593da": {
    "message": "Texti"
  },
  "text_background_color_16e61c3f": {
    "message": "Baklitur texta"
  },
  "text_color_acf75eb6": {
    "message": "Textalitur"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Ef ekki eru nægileg birtuskil milli leturs og bakgrunns er erfitt að lesa texta, sérstaklega ef um er að ræða einstakling sem sér illa."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Hlutfall birtuskila fyrir letur sem er stærra en 18 punkta (14 punkta ef feitletrað) ætti að vera að lágmarki 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Texti (valfrjálst)"
  },
  "text_position_8df8c162": {
    "message": "Staðsetning texta"
  },
  "text_size_887c2f6": {
    "message": "Textastærð"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Hlutfall birtuskila fyrir letur sem er minna en 18 punkta (14 punkta ef feitletrað) ætti að vera að lágmarki 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Forskoðun skjala er í vinnslu. Vinsamlegast reyndu aftur seinna."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Fyrsti haus á síðu ætti að vera H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Hæð Rich Content svæðis er minnkuð."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Hæð Rich Content svæðis er stækkuð."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Efnið er öllum heimilt"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Efnið er með leyfisskylt undir Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Efnið er háð undantekningum - t.d. lögleg notkun, tilvitnunarréttur eða annað undir viðeigandi höfundarréttarlögum"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Ekki hægt að nota lyklaborð með pretty HTML ritlinum. Ýttu á Shift O til að opna hráa html ritilinn."
  },
  "therefore_d860e024": {
    "message": "Þess vegna"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Þeta (afbrigði)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Breið ör niður á við"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Breið vinstri ör"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Breið ör til vinstri"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Breið hægri ör"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Breið ör til hægri"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Breið ör upp á við"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Ekki hægt að sýna þetta skjal í Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Þessi jafna getur ekki birst í grunnsýn."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Þessi mynd er ótiltæk eins og er"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Þetta myndband gæti birt YouTube auglýsingar."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Þó að myndbandið sé með réttan titil í vafranum, uppfærðum við það ekki í gagnagrunninum."
  },
  "thumbnail_e0de666f": {
    "message": "Smámynd"
  },
  "timebar_a4d18443": {
    "message": "Tímaslá"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Titill má ekki vera auður"
  },
  "title_ee03d132": {
    "message": "Titill"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Verður birt: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Verkefni: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Víxla { summary } hóp"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Víxla verkfæraábendingu"
  },
  "tools_2fcf772e": {
    "message": "Verkfæri"
  },
  "top_66e0adb6": {
    "message": "Efst"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Eftirritunarsvæðið er tiltækt í breidd yfir 720px."
  },
  "tray_839df38a": {
    "message": "Bakki"
  },
  "triangle_6072304e": {
    "message": "Þríhyrningur"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Kross (afrakstur)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "sláðu inn Ctrl F9 til að fá aðgang að myndavalkostum. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "sláðu inn Ctrl F9 til að fá aðgang að tenglavalkostum. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "sláðu inn Ctrl F9 til að fá aðgang að töfluvalkostum. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Ekki er hægt að ákvarða url tilfangsvals"
  },
  "underline_applied_ae01ec97": {
    "message": "Undirstrikað notað"
  },
  "underline_removed_3693e17c": {
    "message": "Undirstrikað fjarlægt"
  },
  "union_e6b57a53": {
    "message": "Samtök"
  },
  "unpublished_dfd8801": {
    "message": "óbirt"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Allar óvistaðar breytingar munu tapast."
  },
  "untitled_16aa4f2b": {
    "message": "Án titils"
  },
  "untitled_efdc2d7d": {
    "message": "ónefnt"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Upp og vinstri skáör"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Upp og hægri skáör"
  },
  "up_c553575d": {
    "message": "Upp"
  },
  "updated_link_a827e441": {
    "message": "Uppfærður tengill"
  },
  "upload_document_253f0478": {
    "message": "Hlaða upp skjali"
  },
  "upload_file_fd2361b8": {
    "message": "Hlaða upp skrá"
  },
  "upload_image_6120b609": {
    "message": "Hleð upp mynd"
  },
  "upload_media_ce31135a": {
    "message": "Hlaða upp miðli"
  },
  "upload_record_media_e4207d72": {
    "message": "Hlaða/taka upp margmiðlunarefni"
  },
  "uploading_19e8a4e7": {
    "message": "Hleður upp"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "hástafa bókstafa raðaður listi"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta með stórum staf"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma með stórum staf"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda með stórum staf"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega með stórum staf"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi með stórum staf"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi með stórum staf"
  },
  "uppercase_psi_6395acbe": {
    "message": "Phi með stórum staf"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "hástafa rómverskt tölu raðaður listi"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma með stórum staf"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta með stórum staf"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon með stórum staf"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi með stórum staf"
  },
  "upsilon_33651634": {
    "message": "Ypsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Ör sem bendir upp og niður"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Ör sem bendir upp og niður (breið)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Ör upp á við"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Þríhyrningur sem bendir upp á við"
  },
  "url_22a5f3b8": {
    "message": "Vefslóð"
  },
  "usage_right_ff96f3e2": {
    "message": "Notkunarréttindi:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Notkunarréttindi (áskilið)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Notaðu örvalyklana til að fara á milli valmöguleika."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Notaðu örvahnappana til að velja form."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Notaðu örvahnappana til að velja stærð."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Notið örvalykla til að velja staðsetningu texta."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Notið örvalykla til að velja stærð texta."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Notaðu örvahnappana til að velja stærð útlínu."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Notað af skjálesurum til að lýsa efni { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Notað af skjálesurum til að lýsa efni myndar"
  },
  "user_documents_c206e61f": {
    "message": "Notandaskjöl"
  },
  "user_files_78e21703": {
    "message": "Notandaskrár"
  },
  "user_images_b6490852": {
    "message": "Myndir notanda"
  },
  "user_media_14fbf656": {
    "message": "Margmiðlunarefni notanda"
  },
  "vector_notation_cf6086ab": {
    "message": "Vigur (tákn)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Lóðrétt stika (byggingarlíkan hluta)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Lóðréttir punktar"
  },
  "video_options_24ef6e5d": {
    "message": "Myndbandsvalkostir"
  },
  "video_options_tray_3b9809a5": {
    "message": "Myndbandsvalkostabakki"
  },
  "video_player_b371005": {
    "message": "Myndspilari"
  },
  "video_player_for_9e7d373b": {
    "message": "Myndbandsspilari fyrir "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Myndbandsspilari fyrir { title }"
  },
  "video_url_889d3263": {
    "message": "Vefslóð myndbands"
  },
  "view_all_e13bf0a6": {
    "message": "Sjá allt"
  },
  "view_ba339f93": {
    "message": "Skoða"
  },
  "view_description_30446afc": {
    "message": "Skoða lýsingu"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Skoða flýtileiðir lyklaborð"
  },
  "view_title_description_67940918": {
    "message": "Skoða { title } lýsingu"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Skoða orða- og stafatalingu"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Takmarkanir áhorfenda"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Ekki greindist tengdur og virkur hljóðnemi í tækinu þínu."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Ekki greindist tengd og virk vefmyndavél í tækinu þínu."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Ekki greindist tengd og virk vefmyndavél eða hljóðnemi í tækinu þínu."
  },
  "webcam_disabled_30c66986": {
    "message": "Slökkt á vefmyndavél"
  },
  "webcam_fe91b20f": {
    "message": "Vefmyndavél"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Vefsíður ættu aðeins að hafa einn H1, sem er sjálfkrafa notaður sem titill síðunnar. Fyrsti hausinn í efninu þínu ætti að vera H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Þegar merkingar eru notaðar sem sníða atriði sjónrænt sem lista en sýna ekki lista-sambandið, gætu notendur átt í erfiðleikum við að átta sig á upplýsingunum."
  },
  "white_87fa64fd": {
    "message": "Hvítur"
  },
  "why_523b3d8c": {
    "message": "Hvers vegna"
  },
  "width_492fec76": {
    "message": "Breidd"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Breidd og hæð verða að vera tölur"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }pt"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki-heima"
  },
  "word_count_c77fe3a6": {
    "message": "Orðafjöldi"
  },
  "words_b448b7d5": {
    "message": "Orð"
  },
  "wreath_product_200b38ef": {
    "message": "Sveigfeldi"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Já"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Þú ert á litaspjaldi. Til að fletta á spjaldinu upp, til vinstri, niður eða hægri skaltu nota „W“, „A“, „S“ og „D“ hnappana í sömu röð"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Þú ert á litasleða. Til að vafra um sleðann til vinstri eða hægri skaltu nota „A“ og „D“ hnappana í sömu röð"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Þú ert á alfasleða. Til að vafra um sleðann til vinstri eða hægri skaltu nota „A“ og „D“ hnappana í sömu röð"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Þú ert með óvistaðar breytingar í Tákngerðar bakkanum. Viltu halda áfram án þess að vista þessar breytingar?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Þú gætir þurft að breyta viðbótarhausum til að viðhalda síðustigveldi."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Þú getur ekki hlaðið upp tómri skrá."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Myndinni þinni hefur verið þjappað saman fyrir Icon Maker. Myndir sem eru minni en { size } KB verða ekki þjappaðar."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Vafrastillingarnar útiloka hljóðnemann."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Vafrastillingarnar útiloka vefmyndavélina og hljóðnemann."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Vafrastillingarnar útiloka vefmyndavélina."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Verið getur að vefmyndavélin sé þegar í notkun."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "Innfelld vefslóð YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Draga inn mynd"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Draga út mynd"
  }
};
formatMessage.addLocale({
  is: locale
});